const navigation = {
  ru: {
    about: "О проекте",
    place: "Местоположение",
    infrastructure: "Инфраструктура",
    flats: "Квартиры",
    plans: "Планировки",
    events: "События",
    contacts: "Контакты",
  },
  en: {
    about: "About the Project",
    place: "Location",
    infrastructure: "Infrastructure",
    flats: "Apartments",
    plans: "Floorplans",
    events: "Events",
    contacts: "Contacts",
  },
  cn: {
    about: "关于项目",
    place: "所在地",
    infrastructure: "设施信息",
    flats: "公寓信息",
    plans: "公寓空间布局",
    events: "活动",
    contacts: "联系方式",
  },
};
const infrastructure = {
  ru: {
    wellnessTitle: `Wellness-центр`,
    wellnessText: `Wellness-центр площадью 500&#160;м&#178; включает тренажерный зал, 15-метровый бассейн, SPA-зону, гидромассажную ванну, сауну, хаммам и&#160;массажный кабинет. Окна бассейна выходят в&#160;итальянский дворик, что создает иллюзию открытого пространства. Wellness-центр предназначен только для жителей дома`,
    hallTitle: `Холл-лобби`,
    hallText: `Интерьер холла-лобби с&#160;парадным входом со&#160;стороны набережной Кутузова выдержан в&#160;классическом стиле. Подлинное декоративное убранство холла с&#160;мягкой мебелью придает пространству особую атмосферу и&#160;аристократический уют.`,
    parkingTitle: `Паркинг`,
    parkingText: `Охраняемый паркинг с&#160;грузовыми лифтами KONE на&#160;31&#160;машиноместо расположен на&#160;двух уровнях. Для&nbsp;loft-квартир предусмотрены персональные автолифты для&nbsp;подъема автомобиля на&#160;уровень квартиры`,
    engineeringTitle: `Инженерия`,
    engineeringText: `Инженерия дома оснащена современными системами водоснабжения и&#160;отопления. Канализационные системы изготовлены из&#160;прочного чугуна. Каждая квартира имеет значительный объем выделенной электрической мощности и&#160;индивидуальную систему отопления, кондиционирования и&#160;вентиляции.`,
    facadesTitle: `Фасады`,
    facadesText: `Особняк Кушелева-Безбородко&#160;&#8212; эталонный памятник архитектуры стиля Наполеона III. Это, пожалуй, самый амбициозный девелоперский проект в&#160;Петербурге, в&#160;рамках которого удалось сохранить историческую постройку, дополнив роскошные архитектурные формы современными инфраструктурными решениями.`,
  },
  en: {
    wellnessTitle: `Wellness Centre`,
    wellnessText: `The 500 sq m (5,382 sq ft) Wellness Centre includes a gym, a 15 m (49 ft) swimming pool, a SPA, jacuzzi, hammam and a massage parlour. The windows of the swimming pool look on to a small Italian garden creating an illusion of an open space. The Wellness Centre is a residents only facility.`,
    hallTitle: `Vestibule`,
    hallText: `The grand entrance from Kutuzov Embankment and the interior of the vestibule are done in the Classical Style. Fine period features of the vestibule with its soft furnishings create a special atmosphere of high class and gracious living.`,
    parkingTitle: `Parking`,
    parkingText: `The guarded two-tier parking lot is equipped with freight lifts (KONE) and provides 31 parking spaces. The loft apartments feature personal car lifts right up to the apartment level.`,
    engineeringTitle: `Engineering`,
    engineeringText: `The engineering networks include cutting-edge water supply and heating systems. The sewage systems are equipped with strong and durable cast iron. Each apartment is allocated with enough electric power and its own heating system, air-conditioning and ventilation. `,
    facadesTitle: `Facades`,
    facadesText: `The Kushelev-Bezborodko Mansion is a model architectural design in the style of Napoleon III. It is easily the most ambitious development in St Petersburg, which has at once managed to preserve the period character of the building and to reconcile and enhance its magnificent architectural forms with the best cutting-edge infrastructural solutions.`,
  },
  cn: {
    wellnessTitle: `康乐中心`,
    wellnessText: `500平方米的康乐中心包括健身房、15米的游泳池、SPA区域、按摩浴缸、桑拿房、土耳其浴和按摩中心。游泳池窗户朝向着意大利内院——这制造开放性空间的视觉假象。康乐中心是住户专属享受的。`,
    hallTitle: `大堂`,
    hallText: `从库图佐夫堤岸上（Kutuzova Emb.）正门进的大堂具有古典风格的内装。大堂原有装饰配软体家具添加特殊气氛与贵族作风舒适。`,
    parkingTitle: `停车场`,
    parkingText: `看守的31车位KONE载货电梯的停车场位于两层。为LOFT风格的公寓提供了可将汽车升到公寓层的个人汽车电梯。`,
    engineeringTitle: `工程设施`,
    engineeringText: `本建筑工程设施包含现代供水和供暖系统。污水管系统以坚固的生铁制造。每一个公寓都有相当大的供电量和单独暖气、空调和通风系统。`,
    facadesTitle: `正面`,
    facadesText: `库舍列夫-别兹博罗德科独家住宅是拿破仑三世建筑风格的典范。可以说这是彼得堡最有雄心的发展项目，在其框架内顺利保存了豪华建筑形式的历史建筑与现代设施的相结合。`,
  },
};

export default (type, path, locale) => {
  //TODO: create Map, move layouts to templates (?)
  const layouts = {
    [`navigation`]: `
                      <ul class="modal__navigation">
                        <li class="modal__navigation-item" data-href="#about">
                          <div class="modal__navigation-bg modal__navigation-bg--about">Background</div>
                          <a class="link" href="/${locale || ``}${path}about">${
      locale ? navigation[locale]["about"] : ``
    }</a>
                        </li>
                        <li class="modal__navigation-item" data-href="#place">
                          <div class="modal__navigation-bg modal__navigation-bg--place">Background</div>
                          <a class="link" href="/${locale || ``}${path}place">${
      locale ? navigation[locale]["place"] : ``
    }</a>
                        <li class="modal__navigation-item" data-href="#infrastructure">
                          <div class="modal__navigation-bg modal__navigation-bg--infrastructure">Background</div>
                          <a class="link" href="/${
                            locale || ``
                          }${path}infrastructure">${
      locale ? navigation[locale]["infrastructure"] : ``
    }</a>
                        </li>
                        <li class="modal__navigation-item" data-href="#flats">
                          <div class="modal__navigation-bg modal__navigation-bg--flats">Background</div>
                          <a class="link" href="/${locale || ``}${path}flats">${
      locale ? navigation[locale]["flats"] : ``
    }</a>
                        <li class="modal__navigation-item" data-href="#prices">
                          <div class="modal__navigation-bg modal__navigation-bg--prices">Background</div>
                          <a class="link" href="/${locale || ``}/flats">${
      locale ? navigation[locale]["plans"] : ``
    }</a>
                        <li class="modal__navigation-item" data-href="#events">
                          <div class="modal__navigation-bg modal__navigation-bg--about">Background</div>
                          <a class="link" href="/${
                            locale || ``
                          }${path}events">${
      locale ? navigation[locale]["events"] : ``
    }</a>
                        <li class="modal__navigation-item" data-href="#contacts">
                          <div class="modal__navigation-bg modal__navigation-bg--contacts">Background</div>
                          <a class="link" href="/${
                            locale || ``
                          }${path}contacts">${
      locale ? navigation[locale]["contacts"] : ``
    }</a>
                        </li>
                      </ul>`,
    [`time-line-new`]: `<div class="modal__timeline modal-timeline">
                          <div class="modal-timeline__wrap" id="modal-timeline">
                             <ul class="modal-timeline__stages">
                               <li class="modal-timeline__stage">В&#160;конце 2008 года я&#160;оказался в&#160;историческом доме в&#160;Особняке<br>Кушелева-Безбородко на&#160;Гагаринской улице 1&#160;в &#171;исторический момент&#187;.<br>У&#160;особняка закончился период &#171;лелинградских коммуналок&#187;, вот-вот<br>должна была начаться реконструкция.</li>
                               <li class="modal-timeline__stage">Я&#160;блуждал по&#160;бесконечным пространствам расселённых коммунальных квартир, рассматривая и&#160;фотографируя удивительные &#171;интерьерные натюрморты&#187;. Хозяева съехали, но&#160;оставили стены и&#160;вещи&#160;&#8212; &#171;минималистические инсталляции своей полугероической жизни&#187;, всё как у&#160;Чехова в&#160;&#171;Вишнёвом саду&#187;&#160;&#8212; Фирс-душа остаётся...</li>
                               <li class="modal-timeline__stage">Я&#160;не&#160;вмешивался в&#160;мизансцены, не&#160;редактировал вещи, решая только композиционные и&#160;световые задачи. Это была &#171;очередная смена эпох&#187;.</li>
                               <li class="modal-timeline__stage">Прошло десять лет. Особняк Кушелева-Безбородко опять одна из&#160;жемчужин Блистательного Петербурга, а&#160;фотографии, задуманные, как художественное осмысление жизни Человека и&#160;Города, вдруг стали ещё и&#160;частью истории этого Дома.</li>
                               <li class="modal-timeline__stage">Но&#160;на&#160;берегах Невы, как известно, небывалое&#160;&#8212; бывает. Трущоба снова стала дворцом, соединившим невероятное. С&#160;одной стороны&#160;&#8212; лофты с&#160;автомобильными лифтами прямо в&#160;апартаменты.</li>
                               <li class="modal-timeline__stage">С&#160;другой&#160;&#8212; исторические квартиры с&#160;подлинными восьмиметровыми потолками, каминами и&#160;кариатидами. Ах, да: вид на&#160;крейсер &#171;Аврора&#187; неизбежен.</li>
                             </ul>
                            <div class="modal-timeline__picture">Image</div>
                          </div>
                        </div>`,
    [`timeline`]: `<div class="modal__timeline modal-timeline">
                    <ul class="modal-timeline__list" id="modal-timeline">
                      <li class="modal-timeline__item" data-top="0" data-left="0">
                        <div class="modal-timeline__image">Картинка</div>
                        <div class="modal-timeline__description">
                          <h3 class="modal-timeline__title">1775</h3>
                          <p class="modal-timeline__text">Первое каменное здание на участке нынешнего особняка</p>
                        </div>
                      </li>
                      <li class="modal-timeline__item" data-top="0" data-left="0">
                        <div class="modal-timeline__image">Картинка</div>
                      </li>
                      <li class="modal-timeline__item" data-top="0" data-left="0">
                        <div class="modal-timeline__image">Картинка</div>
                      </li>
                      <li class="modal-timeline__item" data-top="0" data-left="0">
                        <div class="modal-timeline__image">Картинка</div>
                        <div class="modal-timeline__description">
                          <h3 class="modal-timeline__title">1775</h3>
                          <p class="modal-timeline__text">Первое каменное здание на участке нынешнего особняка</p>
                        </div>
                      </li>
                      <li class="modal-timeline__item" data-top="0" data-left="0">
                        <div class="modal-timeline__image">Картинка</div>
                        <div class="modal-timeline__description">
                          <h3 class="modal-timeline__title">1775</h3>
                          <p class="modal-timeline__text">Первое каменное здание на участке нынешнего особняка</p>
                        </div>
                      </li>
                      <li class="modal-timeline__item" data-top="0" data-left="0">
                        <div class="modal-timeline__image">Картинка</div>
                      </li>
                    </ul>
                 </div>`,
    [`infrastructure-wrap`]: `<div class="modal__slider modal-slider" id="infrastructure-slider"></div>`,
    [`infrastructure-parking`]: `<div class="modal-slider__title">${
      locale ? infrastructure[locale][`parkingTitle`] : ``
    }</div>
                                 <ul class="modal-slider__content" id="modal-infrastructure-parking">
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="1">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="2">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="3">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="4">Слайд</div>
                                   </li>
                                    <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="5">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="6">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-parking="7">Слайд</div>
                                   </li>
                                 </ul>
                                 <p class="modal-slider__info">${
                                   locale
                                     ? infrastructure[locale][`parkingText`]
                                     : ``
                                 }</p>`,
    [`infrastructure-wellness`]: `<div class="modal-slider__title">${
      locale ? infrastructure[locale][`wellnessTitle`] : ``
    }</div>
                                 <ul class="modal-slider__content" id="modal-infrastructure-wellness">
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="1">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="2">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="3">Слайд</div>
                                   </li>5
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="4">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="5">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="6">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="7">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-wellness="8">Слайд</div>
                                   </li>
                                 </ul>
                                 <p class="modal-slider__info">${
                                   locale
                                     ? infrastructure[locale][`wellnessText`]
                                     : ``
                                 }</p>`,
    [`infrastructure-hall`]: `<div class="modal-slider__title">${
      locale ? infrastructure[locale][`hallTitle`] : ``
    }</div>
                                 <ul class="modal-slider__content" id="modal-infrastructure-hall">
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-hall="1">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-hall="2">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-hall="3">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-hall="4">Слайд</div>
                                   </li>
                                 </ul>
                                 <p class="modal-slider__info">${
                                   locale
                                     ? infrastructure[locale][`hallText`]
                                     : ``
                                 }</p>`,
    [`infrastructure-facades`]: `<div class="modal-slider__title">${
      locale ? infrastructure[locale][`facadesTitle`] : ``
    }</div>
                                 <ul class="modal-slider__content" id="modal-infrastructure-facades">
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="1">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="2">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="3">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="4">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="5">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="6">Слайд</div>
                                   </li>
                                   <li class="modal-slider__slide">
                                     <div class="modal-slider__image" data-facades="7">Слайд</div>
                                   </li>
                                 </ul>
                                 <p class="modal-slider__info">${
                                   locale
                                     ? infrastructure[locale][`facadesText`]
                                     : ``
                                 }</p>`,
    [`infrastructure-engineering`]: `<div class="modal-slider__title">${
      locale ? infrastructure[locale][`engineeringTitle`] : ``
    }</div>
                                     <ul class="modal-slider__content" id="modal-infrastructure-engineering">
                                       <li class="modal-slider__slide">
                                         <div class="modal-slider__image" data-engineering="1">Слайд</div>
                                       </li>
                                       <li class="modal-slider__slide">
                                         <div class="modal-slider__image" data-engineering="2">Слайд</div>
                                       </li>
                                       <li class="modal-slider__slide">
                                         <div class="modal-slider__image" data-engineering="3">Слайд</div>
                                       </li>
                                     </ul>
                                     <p class="modal-slider__info">${
                                       locale
                                         ? infrastructure[locale][
                                             `engineeringText`
                                           ]
                                         : ``
                                     }</p>`,

    [`flat-floors`]: `<div class="modal-floors" id="floors-modal"></div>`,
    [`flat-gallery`]: `<div class="modal__wrap" id="flat-gallery"></div>`,
    [`flat-plan`]: `<div class="modal-floors" id="flat-plan-modal"></div>`,
    [`flat-house-plan`]: `<div class="modal-floors" id="house-plan"></div>`,
    [`mezzanine`]: `<div class="modal-floors" id="house-mezzanine"></div>`,
    [`form`]: `<div class="modal-form" id="modal-form"></div>`,
    [`modal-video-wrap`]: `<div class="modal__video modal-video" id="modal-video"><iframe width="100%" height="100%" src="" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`,
    [`modal-panorama`]: `<div class="panorama"></div>`,
    [`modal-3d`]: `<div class="tour-3d"><iframe width='100%' height='100%' src='' frameborder='0' allowfullscreen allow='vr'></iframe> </div>`,
  };

  return layouts[type];
};
